import { Player } from "../../store/slices/mediaElementSlice";

interface ExtendedDocument extends Document {
  mozExitFullscreen?: () => void;
  mozFullScreenElement?: Element;
  msExitFullscreen?: () => void;
  msFullscreenElement?: Element;
  webkitExitFullscreen?: () => void;
  webkitFullscreenElement?: Element;
}

interface FullscreenPlayerElement extends Element {
  mozRequestFullScreen?: () => void;
  msRequestFullscreen?: () => void;
  webkitRequestFullscreen?: () => void;
}

interface FullscreenVideoElement extends HTMLVideoElement {
  webkitEnterFullscreen?: () => void;
}

export const enterFullscreen = (
  isMobile: boolean,
  playerElement?: Element,
  videoElement?: HTMLVideoElement
): void => {
  if (playerElement) {
    const fullscreenPlayerContainer: FullscreenPlayerElement = playerElement;

    if (fullscreenPlayerContainer.requestFullscreen) {
      fullscreenPlayerContainer.requestFullscreen();
    } else if (fullscreenPlayerContainer.mozRequestFullScreen) {
      fullscreenPlayerContainer.mozRequestFullScreen();
    } else if (fullscreenPlayerContainer.webkitRequestFullscreen) {
      fullscreenPlayerContainer.webkitRequestFullscreen();
    } else if (fullscreenPlayerContainer.msRequestFullscreen) {
      fullscreenPlayerContainer.msRequestFullscreen();
    } else if (isMobile && videoElement) {
      const fullscreenVideoContainer: FullscreenVideoElement = videoElement;

      if (fullscreenVideoContainer.webkitEnterFullscreen) {
        fullscreenVideoContainer.webkitEnterFullscreen();
      }
    }
  }
};

export const exitFullscreen = (): void => {
  try {
    const extendedDocument: ExtendedDocument = document;
    if (extendedDocument.exitFullscreen) {
      extendedDocument.exitFullscreen().catch(() => {});
    } else if (extendedDocument.mozExitFullscreen) {
      extendedDocument.mozExitFullscreen();
    } else if (extendedDocument.webkitExitFullscreen) {
      extendedDocument.webkitExitFullscreen();
    } else if (extendedDocument.msExitFullscreen) {
      extendedDocument.msExitFullscreen();
    }
  } catch (e) {
    /* empty */
  }
};

export const toggleFullscreen = ({
  element,
  player
}: {
  element?: Element;
  player: Player;
}): void => {
  if (element) {
    const fullscreenElement =
      (document as ExtendedDocument).fullscreenElement ||
      (document as ExtendedDocument).mozFullScreenElement ||
      (document as ExtendedDocument).webkitFullscreenElement ||
      (document as ExtendedDocument).msFullscreenElement;

    if (!fullscreenElement) {
      player.enterFullscreen?.();
    } else {
      exitFullscreen();
    }
  }
};
